import React from 'react';
import { useState } from 'react';
import { UseAppSelector, UseAppDispatch } from '../../../store/hooks';
import { toggleChecked, calcUC, calcBE, calcMPU, calcDPH, calcDPU, calcPP, calcSV, calcSTUE, calcPTUF } from '../../../store/statsEngine';
import Fade from 'react-reveal/Fade';
import FormatCurrency from '../../../scripts/formatCurrency';

import * as styles from '../../../styles/desktop/calculators/upgradeSelect.module.css';

function UpgradeSelect() {
    const dispatch = UseAppDispatch();

    // UI states
    const [isEquipmentActive, setEquipmentActive] = useState('false');
    const [isSecurityActive, setSecurityActive] = useState('false');
    const [isStaffActive, setStaffActive] = useState('false');

    // Toggle active className
    function handleEquipmentToggle() {
        setEquipmentActive(!isEquipmentActive);
    }
    function handleSecurityToggle() {
        setSecurityActive(!isSecurityActive);
    }
    function handleStaffToggle() {
        setStaffActive(!isStaffActive);
    }

    // Access redux store slice
    const statsEngine = UseAppSelector((state) => state.stats);
    const dataObject = statsEngine.find(item => item.title === 'business-data');
    const data = dataObject.data;

    const equipmentUpgrade = data.find(item => item.title === 'equip-upgrade');
    const staffUpgrade = data.find(item => item.title === 'staff-upgrade');
    const securityUpgrade = data.find(item => item.title === 'security-upgrade');
    const saleValues = data.find(item => item.title === 'sale-values');
    const DPUValues = data.find(item => item.title === 'DPU-values');

    // click handlers
    function handleChecked(id) {
        const checkedState = statsEngine.find(item => item.id === id);
        dispatch(toggleChecked({ id: id, checked: !checkedState.checked }));
    }

    function handleUpgradeClick(id, data) {
        handleChecked(id);
        dispatch(calcBE({ id: id, data: data }));
        dispatch(calcMPU({ id: id, data: data }));
        dispatch(calcDPU({ data: DPUValues }));
        dispatch(calcDPH({}));
        dispatch(calcUC({ id: id, data: data }));
        dispatch(calcPP({}));
        dispatch(calcSTUE({ id: id }));
        dispatch(calcPTUF({ id: id, data: data }));
        dispatch(calcSV({ data: saleValues }));
    }

    return (
        <section className={styles.UpgradeSection}>
            <Fade bottom cascade>
                <div>
                    <div className={styles.UpgradeTitle}>
                        <h2>- Upgrades Select -</h2>
                        <p>Choose the upgrades, or desired upgrades, for your Business!</p>
                    </div>
                </div>
                <div className={styles.Parent}> 
                    <div className={styles.Card}>
                        <div className={styles.ImageBox} style={{backgroundImage: `url(${equipmentUpgrade.image})`}}>
                            <div className={styles.Label}>
                                <div className={isEquipmentActive ? styles.Icon : [styles.Icon, styles.Active].join(' ')}>
                                    <svg className={isEquipmentActive ? styles.Svg : [styles.Svg, styles.Active].join(' ')} xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi bi-wrench" viewBox="0 0 16 16">
                                        <path d="M.102 2.223A3.004 3.004 0 0 0 3.78 5.897l6.341 6.252A3.003 3.003 0 0 0 13 16a3 3 0 1 0-.851-5.878L5.897 3.781A3.004 3.004 0 0 0 2.223.1l2.141 2.142L4 4l-1.757.364L.102 2.223zm13.37 9.019.528.026.287.445.445.287.026.529L15 13l-.242.471-.026.529-.445.287-.287.445-.529.026L13 15l-.471-.242-.529-.026-.287-.445-.445-.287-.026-.529L11 13l.242-.471.026-.529.445-.287.287-.445.529-.026L13 11l.471.242z"/>
                                    </svg>
                                </div>
                                <div className={styles.Info}>
                                    <div className={styles.Main}>{equipmentUpgrade.display_title}</div>
                                    <div className={styles.Sub}>GTA {FormatCurrency(equipmentUpgrade.cost)}</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.Button}>
                            <input type="checkbox" id="equip-upgrade" onClick={() => {handleEquipmentToggle(); handleUpgradeClick(4, equipmentUpgrade)}}></input>
                            <label htmlFor="equip-upgrade">
                                <div className={styles.Dot}></div>
                                <div className={styles.Text}>Choose Upgrade</div>
                            </label>
                        </div>
                    </div>

                    <div className={styles.Card}>
                        <div className={styles.ImageBox} style={{backgroundImage: `url(${securityUpgrade.image})`}}>
                            <div className={styles.Label}>
                                <div className={isSecurityActive ? styles.Icon : [styles.Icon, styles.Active].join(' ')}>
                                    <svg className={isSecurityActive ? styles.Svg : [styles.Svg, styles.Active].join(' ')} xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi bi-lock-fill" viewBox="0 0 16 16">
                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                                    </svg>
                                </div>
                                <div className={styles.Info}>
                                    <div className={styles.Main}>{securityUpgrade.display_title}</div>
                                    <div className={styles.Sub}>GTA {FormatCurrency(securityUpgrade.cost)}</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.Button}>
                            <input type="checkbox" id="sec-upgrade" onClick={() => {handleSecurityToggle(); handleUpgradeClick(5, securityUpgrade)}}></input>
                            <label htmlFor="sec-upgrade">
                                <div className={styles.Dot}></div>
                                <div className={styles.Text}>Choose Upgrade</div>
                            </label>
                        </div>
                    </div>

                    <div className={styles.Card}>
                        <div className={styles.ImageBox} style={{backgroundImage: `url(${staffUpgrade.image})`}}>
                            <div className={styles.Label}>
                                <div className={isStaffActive ? styles.Icon : [styles.Icon, styles.Active].join(' ')}>
                                    <svg className={isStaffActive ? styles.Svg : [styles.Svg, styles.Active].join(' ')} xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi bi-person-plus-fill" viewBox="0 0 16 16">
                                        <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                        <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                                    </svg>
                                </div>
                                <div className={styles.Info}>
                                    <div className={styles.Main}>{staffUpgrade.display_title}</div>
                                    <div className={styles.Sub}>GTA {FormatCurrency(staffUpgrade.cost)}</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.Button}>
                            <input type="checkbox" id="staff-upgrade" onClick={() => {handleStaffToggle(); handleUpgradeClick(6, staffUpgrade)}}></input>
                            <label htmlFor="staff-upgrade">
                                <div className={styles.Dot}></div>
                                <div className={styles.Text}>Choose Upgrade</div>
                            </label>
                        </div>
                    </div>
                </div>
            </Fade>
        </section>
    )
}

export default UpgradeSelect;